import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import AppShell from './components/app-shell';
import { routes } from './routes';

import { getAppBasename } from './utils/history';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <AppShell />,
      children: routes
    }
  ],
  {
    basename: getAppBasename()
  }
);

const container = document.getElementById('app-container');
const root = createRoot(container);
root.render(<RouterProvider router={router} />);
